var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNeutral = function SvgNeutral(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    rx: 10.5,
    fill: "#CAC6B9",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M7.22275 7.90057H6.57275C6.12402 7.90057 5.76025 8.26434 5.76025 8.71307V14.2901C5.76025 14.7388 6.12402 15.1026 6.57275 15.1026H7.22275C7.67149 15.1026 8.03525 14.7388 8.03525 14.2901V8.71307C8.03525 8.26434 7.67149 7.90057 7.22275 7.90057Z",
    stroke: "#7E7762",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8.03516 9.15994V13.477C8.03516 13.908 8.20636 14.3213 8.51111 14.6261C8.81585 14.9308 9.22918 15.102 9.66016 15.102H13.383C13.6801 15.102 13.9689 15.0044 14.205 14.8241C14.4411 14.6438 14.6113 14.3909 14.6895 14.1043L15.7501 10.2108C15.8048 10.0099 15.8125 9.79914 15.7725 9.59484C15.7325 9.39053 15.646 9.1982 15.5196 9.03277C15.3932 8.86735 15.2304 8.73329 15.0438 8.64102C14.8572 8.54875 14.6518 8.50074 14.4436 8.50073H12.2255V6.43752C12.2255 6.1502 12.1114 5.87465 11.9082 5.67149C11.705 5.46832 11.4295 5.35419 11.1422 5.35419H11.1227C10.9433 5.35422 10.7668 5.39877 10.6089 5.48386C10.451 5.56895 10.3167 5.6919 10.2181 5.84169L8.03516 9.15994Z",
    stroke: "#7E7762",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgNeutral;